export default "__VITE_ASSET__CPXZLxVG__"